import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../store';
import { ChangePasswordInfo } from '../../models/account';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CryptoService} from '../../services/crypto.service';
import { SmartPowerReportService} from '../../services/smart-power-report.service';
import { reportTypeOption, reportCategoryOption, SmartPowerReportGrade } from '../../shareModel';
import { SelectItem } from 'primeng/api';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as fromFeature from '../../my-features';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {TranslateService} from '@ngx-translate/core';
@Component({
  standalone: false,
  selector: 'app-report-preview',
  templateUrl: './report-preview.component.html',
  styleUrls: ['./report-preview.component.css']
})
export class ReportPreviewComponent implements OnInit, AfterViewInit {
  @ViewChild('masonryContainer') container!: ElementRef;
  @ViewChild('masonryContainer') set masonryContainer(element: ElementRef) {
    if (element) {
      this.layoutMasonry();
      this.setProgress();
    }
  }
  ChangePasswordInfo: ChangePasswordInfo = {
    Account: '',
    Package: '',
    Password: '',
    NewPassword: '',
  };
  reportInfo = {
    reportRang: null,
    type: null,
    week: null,
    month: null,
    systemWellnessStauts: null,
    systemStability: null,
    riskRate: null,
    coverageRate: null,
    loadDistribution: null,
    loadDistributionStauts: null,
    nearLoadCapacityLimit: null,
    totalAvgLoad: null,
    powerProtectionStauts: null,
    affectedDevices: null,
    onlineDevices: null,
    availableDevices: null,
    powerCommunityBenchmark: null,
    powerEventsIntercepted: null,
    powerEventDiff: null,
    powerEventPercent: null,
    energySavingStauts: null,
    energyConsumptionDiff: null,
    energyConsumption: null,
    lastEnergyConsumption: null,
    energyConsumptionDiffPec: null,
    energyCommunityRank: null,
    energyCO2e: null,
    energyTrees: null,
    normalCnt: null,
    warningCnt: null,
    criticalCnt: null,
    offlineCnt: null,
    SystemStabilityGrade: null,
    LoadDistributionGrade: null,
    PowerQualityGrade: null,
    EnergyConsumptionGrade: null,
  };
  columnCount = 2;
  systemStabilityChart = {};
  chartSystemStabilityOption: any;
  loadDistributionChart = {};
  chartLoadOption: any;
  energySavingChart = {};
  chartEnergySavingOption: any;
  powerProtectionChart = {};
  chartPowerProtectionOption: any;
  reportType = 0; // default monthly
  reportId = 0; // default monthly
  startTs = 0; // ts
  endTs = 0; // ts
  params = {}
  private componentDestroyed = new Subject();
  currentUser = '';
  IsSuperAdmin = false;
  IsAdmin = false;
  isMsp = false;
  regionId: number;
  
  curveData = []
  loadDistributionAvgData = []
  loadDistributionPeakData = []
  isDataLoaded = false;
  chartPlugins = [];

  constructor(private router: Router, 
    private store: Store<fromStore.State>,
    private smartPowerReportService: SmartPowerReportService,
    private cryptoService: CryptoService, 
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private translateService: TranslateService
  ) {
    const params = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashStr')).split(',');
    if (params !== null) {
      this.reportType = parseInt(params[0]);
      this.reportId = parseInt(params[1]);
      this.startTs = parseInt(params[2]);
      this.endTs = parseInt(params[3]);
      const param = {
        otp: '',
        Id: this.reportId
      }
      this.store.dispatch(new fromFeature.GetSmartPowerReport(param));
    }

    this.store.pipe(select(fromStore.getCurrentUser)).pipe(takeUntil(this.componentDestroyed)).subscribe((user: any) => {
      this.currentUser = user.currentUser;
        this.IsSuperAdmin = user.authority === 2;
        this.isMsp = user.isMsp;
        this.regionId = user.RegionId;
    });

    this.store.select(fromStore.GetSmartPowerReport).pipe(takeUntil(this.componentDestroyed)).subscribe((res: any) => {
      if (res !== undefined) {
        if (res && Object.keys(res).length > 0) {
          this.reportInfo.type = res.ReportType;
          if (res.Week !== undefined) {
            this.reportInfo.week = res.Week;
          }

          // System Wellness
          this.reportInfo.systemWellnessStauts = '';
          this.reportInfo.SystemStabilityGrade = res.SystemStabilityGrade;
          this.reportInfo.systemStability = res.Stability;
          this.reportInfo.riskRate = res.RiskRate;
          this.reportInfo.coverageRate = res.CoverageRate;
          this.reportInfo.normalCnt = res.NormalCnt;
          this.reportInfo.warningCnt = res.WarningCnt;
          this.reportInfo.criticalCnt = res.CriticalCnt;
          this.reportInfo.offlineCnt = res.OfflineCnt;

          // energy Saving
          this.reportInfo.energySavingStauts = '';
          this.reportInfo.EnergyConsumptionGrade = res.EnergyConsumptionGrade;
          // this.reportInfo.energyCommunityRank = res.CommunityRank;
          const cur = res.Consumption;
          const last = res.LastConsumption;
          this.reportInfo.energyConsumption = (cur != null) ? Number((cur / 1000).toFixed(2)) : null;
          this.reportInfo.lastEnergyConsumption = (last != null) ? Number((last / 1000).toFixed(2)) : null;

          if (cur != null) {
              if (last == null) {
                  // 上週完全沒有資料 (null 或 undefined)
                  // 差值與百分比直接給 null，不進行數學計算
                  this.reportInfo.energyConsumptionDiff = null;
                  this.reportInfo.energyConsumptionDiffPec = null;

              } else if (last === 0) {
                  // 上週有資料，但用電量剛好是 0
                  // 差值就是本週用電量
                  this.reportInfo.energyConsumptionDiff = Number((cur / 1000).toFixed(2));
                  // 0 變成其他數字，成長率定義為 100%；如果本週也是 0，就是 0%
                  this.reportInfo.energyConsumptionDiffPec = (cur === 0) ? 0 : 100;

              } else {
                  // 上週有正常數值 (不為 0) 且本週有值 -> 正常計算
                  this.reportInfo.energyConsumptionDiff = Number(((cur - last) / 1000).toFixed(2));
                  this.reportInfo.energyConsumptionDiffPec = Number((((cur - last) / last) * 100).toFixed(2));
              }
          } else {
              // 本週為 null (無論上週有沒有值)
              // 兩者都設定為 null，讓前端 UI 渲染成 '-'
              this.reportInfo.energyConsumptionDiff = null;
              this.reportInfo.energyConsumptionDiffPec = null;
          }
          this.reportInfo.energyCO2e = (res.CO2e != null) ? Number((res.CO2e / 1000 / 1000).toFixed(2)) : null; //CO2 kg
          this.reportInfo.energyTrees = (res.Trees != null) ? Number((res.Trees / 1000 / 1000).toFixed(2)) : null;;

          // Protection Summary
          this.reportInfo.powerEventsIntercepted = res.PowerEvents;
          if (res.LastPowerEvents !== undefined) {
            const cur = res.PowerEvents;
            const last = res.LastPowerEvents;
            
            this.reportInfo.powerEventDiff = cur - last;

            if (last === 0) {
              if (cur === 0) {
                this.reportInfo.powerEventPercent = 0;   // 0 到 0 視為 0%
              } else {
                this.reportInfo.powerEventPercent = 100; // 0 到 任何正數，直接封頂顯示 100%
              }
            } else {
              // 正常計算
              this.reportInfo.powerEventPercent = Number(((this.reportInfo.powerEventDiff / last) * 100).toFixed(2));
            }
          }

          // Power Risk Level
          this.reportInfo.powerProtectionStauts = '';
          this.reportInfo.PowerQualityGrade = res.PowerQualityGrade;
          this.reportInfo.onlineDevices = res.OnlineDevices;
          this.reportInfo.availableDevices = res.AvailableDevices;
          this.reportInfo.affectedDevices = res.AffectedDevices;
          // this.reportInfo.powerCommunityBenchmark = res.PowerEvents / res.AffectedDevices; //%

          // Load Distribution
          this.reportInfo.loadDistributionStauts = '';
          this.reportInfo.LoadDistributionGrade = res.LoadDistributionGrade;
          this.reportInfo.loadDistribution = res.PeakLoadLv4Cnt + res.PeakLoadLv5Cnt + res.PeakLoadLv6Cnt;
          this.reportInfo.nearLoadCapacityLimit = res.NearLoadTimes;
          this.reportInfo.totalAvgLoad = res.AvgLoad;
          
          this.loadDistributionAvgData.push((res.AvgLoadLv1Cnt + res.AvgLoadLv2Cnt), (res.AvgLoadLv3Cnt + res.AvgLoadLv4Cnt), (res.AvgLoadLv5Cnt + res.AvgLoadLv6Cnt));
          this.loadDistributionPeakData.push((res.PeakLoadLv1Cnt + res.PeakLoadLv2Cnt), (res.PeakLoadLv3Cnt + res.PeakLoadLv4Cnt), (res.PeakLoadLv5Cnt + res.PeakLoadLv6Cnt));
          this.curveData = Array.isArray(res.CurveData) ? res.CurveData.map((c) => ({ ...c })) : res.CurveData;
          
          // formate report date rang
            this.formatReportRange(res);
            this.rebuildUI();
        }
        this.UI();
        this.isDataLoaded = true;
        this.ngxService.stop();
      }
    })
  }

  ngOnInit() {
    this.ngxService.start();
    // this.UI();
  }

  ngAfterViewInit() {
    this.updateColumnCount();
    setTimeout(() => {
      this.layoutMasonry();
      this.setProgress();
    }, 100);
    const dataMax = Math.max(...this.loadDistributionPeakData, ...this.loadDistributionAvgData);
    this.setChartLoadOption(dataMax);
    this.setChartOption();
    this.setChartPlugins();
  }

  UI() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-landing');
    body.classList.remove('body-login');
    body.classList.remove('mobile-toggle');
    this.getReportInfo();
    this.setProgress();
  }

  reportToScorePipe(value) {
    if ( value === null || value === undefined || typeof value !== "number" || isNaN(value) || value === 0) {
      return "-";
    }
    const primaryValue: number = value;
    return SmartPowerReportGrade[primaryValue];
  }

  createDiagonalPattern(color: string): CanvasPattern | string {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) return color;

    canvas.width = 10;
    canvas.height = 10;

    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(0, 10);
    ctx.lineTo(10, 0);
    ctx.stroke();

    const pattern = ctx.createPattern(canvas, 'repeat');
    return pattern || color;
  }

  getReportInfo() {
    const stabilityData = {
      Stability: [],
      ReportDate: [],
      StabilityMA: []
    }
    const energySavingData = {
      Consumption: [],
      ReportDate: [],
      ConsumptionMA: []
    }
    const powerProtectionData = {
      PowerEvents: [],
      ReportDate: [],
      PowerEventsMA: []
    }
    if (this.curveData !== undefined && this.curveData.length > 0) {
      const data = [...this.curveData].sort((a, b) => {
        return new Date(a.ReportDate).getTime() - new Date(b.ReportDate).getTime();
      });
      for (const i in data) {
        const info = data[i];
        if (info !== undefined && info !== null) {
          const reportDate = info.ReportDate || "";

          // Stability (0~100%)
          stabilityData.Stability.push(info.Stability != null ? Math.min(100, Number(info.Stability.toFixed(2))) : null);
          stabilityData.ReportDate.push(reportDate);
          stabilityData.StabilityMA.push(info.StabilityMA != null ? Math.min(100, Number(info.StabilityMA.toFixed(2))) : null);
          
          // Power Anomaly Insights
          powerProtectionData.PowerEvents.push(info.PowerEvents != null ? Number(info.PowerEvents.toFixed(4)) : null);
          powerProtectionData.ReportDate.push(reportDate);
          powerProtectionData.PowerEventsMA.push(info.PowerEventsMA != null ? Number(info.PowerEventsMA.toFixed(4)) : null);

          // Estimated Consumption Profile
          energySavingData.Consumption.push(info.Consumption != null ? Number((info.Consumption / 1000).toFixed(2)) : null);
          energySavingData.ReportDate.push(reportDate);
          energySavingData.ConsumptionMA.push(info.ConsumptionMA != null ? Number((info.ConsumptionMA / 1000).toFixed(2)) : null);
        }
      }
    }
    let reportTypeAvgStr = 'Wk Avg.';
    if (this.reportType == 1) {
      reportTypeAvgStr = 'Mo Avg.';
    }
    this.systemStabilityChart = {
      labels: stabilityData.ReportDate,
      datasets: [
        {
          label: this.translateService.instant('Time at risk'),
          // data: [90, 88, 89, 93, 72, 91, 92],
          data: stabilityData.Stability,
          fill: true,
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 2,
          pointBackgroundColor: 'rgba(54, 162, 235, 1)',
          pointBorderColor: '#fff',
          pointRadius: 5,
          pointHoverRadius: 7,
          tension: 0.3
        },
        {
          label: this.translateService.instant(reportTypeAvgStr),
          // data: [85, 85, 85, 85, 85, 85, 85],
          data: stabilityData.StabilityMA,
          fill: true,
          backgroundColor: 'rgba(148, 163, 184, 0.2)',
          borderColor: 'rgba(150, 150, 150, 0.8)',
          borderWidth: 1,
          borderDash: [5, 5],
          pointBackgroundColor: 'rgba(150, 150, 150, 0.8)',
          pointBorderColor: '#fff',
          pointRadius: 5,
          pointHoverRadius: 7,
          tension: 0
        }
      ]
    };

    const colors = ['#5d8910', '#faa21d', '#FF0000'];
    this.loadDistributionChart = {
      labels: [this.translateService.instant('Base'),this.translateService.instant('Mid'), this.translateService.instant('High')],
      datasets: [
        {
          label: this.translateService.instant('Peak Load'),
          data: this.loadDistributionPeakData,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1
        },{
          label: this.translateService.instant('Avg. Load'),
          data: this.loadDistributionAvgData,
          backgroundColor: colors.map(color => this.createDiagonalPattern(color)),
          borderColor: colors,
          borderWidth: 1
        }
      ]
    };

    this.powerProtectionChart = {
      labels: powerProtectionData.ReportDate,
      datasets: [
        {
          label: this.translateService.instant('Power Events'),
          data: powerProtectionData.PowerEvents,
          fill: true,
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 2,
          pointBackgroundColor: 'rgba(54, 162, 235, 1)',
          pointBorderColor: '#fff',
          pointRadius: 5,
          pointHoverRadius: 7,
          tension: 0.3
        },
        {
          label: this.translateService.instant(reportTypeAvgStr),
          data: powerProtectionData.PowerEventsMA,
          fill: true,
          backgroundColor: 'rgba(148, 163, 184, 0.2)',
          borderColor: 'rgba(150, 150, 150, 0.8)',
          borderWidth: 1,
          borderDash: [5, 5],
          pointBackgroundColor: 'rgba(150, 150, 150, 0.8)',
          pointBorderColor: '#fff',
          pointRadius: 5,
          pointHoverRadius: 7,
          tension: 0
        }
      ]
    };

    this.energySavingChart = {
      labels: energySavingData.ReportDate,
      datasets: [
        {
          label: this.translateService.instant('Est. Consumption'),
          data: energySavingData.Consumption,
          fill: true,
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 2,
          pointBackgroundColor: 'rgba(54, 162, 235, 1)',
          pointBorderColor: '#fff',
          pointRadius: 5,
          pointHoverRadius: 7,
          tension: 0.3
        },
        {
          label: this.translateService.instant(reportTypeAvgStr),
          data: energySavingData.ConsumptionMA,
          fill: true,
          backgroundColor: 'rgba(148, 163, 184, 0.2)',
          borderColor: 'rgba(150, 150, 150, 0.8)',
          borderWidth: 1,
          borderDash: [5, 5],
          pointBackgroundColor: 'rgba(150, 150, 150, 0.8)',
          pointBorderColor: '#fff',
          pointRadius: 5,
          pointHoverRadius: 7,
          tension: 0
        }
      ]
    };
  }

  @HostListener('window:resize')
  onResize() {
    this.updateColumnCount();
    this.layoutMasonry();
  }

  updateColumnCount() {
    this.columnCount = window.innerWidth < 768 ? 1 : 2;
  }

  layoutMasonry() {
    if (!this.container || !this.container.nativeElement) {
      return; // 防止報錯
    }
    const container = this.container.nativeElement;
    if (!container) return;

    const items = Array.from(container.children) as HTMLElement[];
    const gap = 24;
    const columnHeights = new Array(this.columnCount).fill(0);
    const containerWidth = container.offsetWidth;
    const columnWidth = (containerWidth - gap * (this.columnCount - 1)) / this.columnCount;

    items.forEach((item: HTMLElement) => {
      const minHeight = Math.min(...columnHeights);
      const columnIndex = columnHeights.indexOf(minHeight);

      const x = columnIndex * (columnWidth + gap);
      const y = columnHeights[columnIndex];

      item.style.position = 'absolute';
      item.style.left = `${x}px`;
      item.style.top = `${y}px`;
      item.style.width = `${columnWidth}px`;

      columnHeights[columnIndex] += item.offsetHeight + gap;
    });

    const maxHeight = Math.max(...columnHeights);
    container.style.height = `${maxHeight}px`;
  }

  formatReportRange(res) {
  const startDateObj = new Date((this.startTs * 1000));
  
  let endDateObj;
  if (res.ReportType == 1) { // Monthly
    const year = startDateObj.getFullYear();
    const month = startDateObj.getMonth();
    endDateObj = new Date(year, month + 1, 0);
  } else { //Weekly
    endDateObj = new Date((this.endTs * 1000));
  }

  // formatDate
  const startYY = String(startDateObj.getFullYear());
  const startMM = String(startDateObj.getMonth() + 1).padStart(2, '0');
  const startDD = String(startDateObj.getDate()).padStart(2, '0');
  const endMM = String(endDateObj.getMonth() + 1).padStart(2, '0');
  const endDD = String(endDateObj.getDate()).padStart(2, '0');
  const formattedStartDate = `${startYY}/${startMM}/${startDD}`;
  const endDateFormatDate = `${endMM}/${endDD}`;
  this.reportInfo.reportRang = `${formattedStartDate} - ${endDateFormatDate}`;
}

  setProgress() {
    const energySaving = document.getElementsByClassName('energySaving-progress')[0] as HTMLElement;
    const powerQuality = document.getElementsByClassName('powerQuality-progress')[0] as HTMLElement;
    const energy = this.reportInfo.energyCommunityRank;
    const power = this.reportInfo.powerCommunityBenchmark;
    if (energySaving) {
      energySaving.style.setProperty('--value', energy.toString());
    }
    if (powerQuality) {
      powerQuality.style.setProperty('--value', power.toString());
    }
  }

  goBack() {
    this.router.navigate(['smart-power-report']);
  }

  getDetail(item) { // report view item
    if (item !== null) {
      let paramStr = ''; // weekly,reportType,startTs,endTs 提供參數給Detail Filter
      paramStr = paramStr + this.reportType + ',' + this.reportId + ',' + item.value + ',' + this.startTs + ',' + this.endTs;
      const hashStr = this.cryptoService.aesEncrypt(paramStr)
      this.router.navigate(['smart-power-report/report/detail/', hashStr]);
    } else { // SYSTEM WELLNESS
      this.smartPowerReportService.SetSmartReportType = this.reportType;
      this.router.navigate(['events'])
    }
  } 

  getReportCategoryOption(type) {
    for (let i = 0; i < reportCategoryOption.length; i++) {
      const label = reportCategoryOption[i].label.toLowerCase().trim();
      if (label && label.indexOf(type.toLowerCase().trim()) !== -1) {
        return reportCategoryOption[i];
      }
    }
    return null;
  }

  rebuildUI () {
    
    this.reportInfo.systemWellnessStauts = this.reportToScorePipe(this.reportInfo.SystemStabilityGrade);
    this.reportInfo.loadDistributionStauts = this.reportToScorePipe(this.reportInfo.LoadDistributionGrade);
    this.reportInfo.powerProtectionStauts = this.reportToScorePipe(this.reportInfo.PowerQualityGrade);
    this.reportInfo.energySavingStauts = this.reportToScorePipe(this.reportInfo.EnergyConsumptionGrade);

    const dataMax = Math.max(...this.loadDistributionPeakData, ...this.loadDistributionAvgData);
    this.setChartLoadOption(dataMax);
    this.setChartOption();
    this.setChartPlugins();
  }

  routeToDashboard () {
    this.router.navigate(['dashboard']);
  }
  
  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

  private createChartOption(yAxisLabel?: string): any {
    const isPercent = yAxisLabel === '%';
    if (yAxisLabel === '%') {
      yAxisLabel = ''
    }
    const ticks: any = {
      beginAtZero: true,
      padding: 10,
      color: '#666666',
      fontColor: '#666666',
    };
    if (isPercent) {
      ticks.min = 0;
      ticks.max = 100;
      ticks.callback = (value: number | string) => `${value}%`;
    }
    return {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      // Chart.js v2 legacy legend
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          font: {
            size: 12
          }
        }
      },
      plugins: {
        // Chart.js v3/v4 legend
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            font: {
              size: 12
            }
          }
        },
        datalabels: {
          display: false,
        },
      },
      scales: {
        // Chart.js v3/v4
        y: {
          ticks,
          grid: {
            drawTicks: false,
            color: '#f0f0f0'
          },
          position: 'left',
          title: {
            display: !!yAxisLabel,
            text: yAxisLabel
          },
        },
      },
    };
  }
  setChartOption() {
    this.chartSystemStabilityOption = this.createChartOption('%');
    this.chartEnergySavingOption = this.createChartOption(this.translateService.instant('Est. kWh'));
    let powerProtectionStr = "Avg. Weekly Protection/Device"
    if (this.reportType == 1) { // month
      powerProtectionStr = "Avg. Monthly Protection/Device"
    }
    this.chartPowerProtectionOption = this.createChartOption(this.translateService.instant(powerProtectionStr));
  }

  setChartLoadOption(dataMax: number | undefined) {
    const maxValue = dataMax !== undefined ? dataMax : 0;
    const yTicks = {
      stepSize: maxValue <= 10 ? 1 : undefined,
      padding: 10,
      color: '#666666',
      fontColor: '#666666',
    };

    const legendLabels = {
      color: '#000000',
      boxWidth: 40,
      boxHeight: 15,
      generateLabels: (chart: any) => {
        return chart.data.datasets.map((dataset: any, i: number) => {
          const meta = chart.getDatasetMeta(i);
          return {
            text: dataset.label,
            fillStyle: i === 0 ? '#999999' : this.createDiagonalPattern('#999999'),
            strokeStyle: '#999999',
            hidden: meta.hidden,
            datasetIndex: i,
            lineWidth: 1,
          };
        });
      }
    };

    this.chartLoadOption = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      // Chart.js v2 legacy legend
      legend: {
        labels: legendLabels,
        position: 'bottom',
      },
      plugins: {
        // Chart.js v3/v4 legend
        legend: {
          labels: legendLabels,
          position: 'bottom',
        },
        datalabels: {
          display: true,
          anchor: 'end', 
          align: 'top',
          offset: 0,
          color: '#666666',
          formatter: (value: number | null | undefined) => {
            if (value === null || value === undefined) {
              return '';
            }
            return `${value}`;
          },
          font: {
            size: 11,
          },
          clip: false,
          clamp: false,
        },
      },
      scales: {
        // Chart.js v3/v4
        y: {
          min: 0,
          max: maxValue <= 10 ? 10 : undefined,
          ticks: yTicks,
          grid: {
            drawTicks: false,
            color: '#f0f0f0'
          },
          position: 'left',
          title: {
            display: true,
            text: this.translateService.instant('Devices')
          },
        },
      },
    };
  }

  setChartPlugins(){
    const backgroundColorPlugin = {
      id: 'load-zone-background',
      beforeDraw(chart: { ctx: any; scales: { [x: string]: any; }; }) {
        const ctx = chart.ctx;
        const scales = chart.scales || {};
        const xAxis = scales['x'] || scales['x-axis-0']; // v3/v4: x, v2: x-axis-0
        const yAxis = scales['y'] || scales['y-axis-0']; // v3/v4: y, v2: y-axis-0

        if (!ctx || !xAxis || !yAxis || !xAxis.ticks || xAxis.ticks.length === 0) {
          return;
        }

        const bgColors = [
          'rgba(255, 255, 255, 0)',
          'rgba(255, 152, 0, 0.08)',
          'rgba(244, 67, 54, 0.08)',
        ];

        const tickCount = xAxis.ticks.length;

        xAxis.ticks.forEach((_: any, i: number) => {
          const x = xAxis.getPixelForTick(i);
          const segmentWidth = xAxis.width / tickCount;
          const startX = x - segmentWidth / 2;

          ctx.save();
          ctx.fillStyle = bgColors[i] || bgColors[bgColors.length - 1];
          ctx.fillRect(startX, yAxis.top, segmentWidth, yAxis.height);
          ctx.restore();
        });
      }
    };
    this.chartPlugins = [ChartDataLabels, backgroundColorPlugin];
  }

}
